export default __webpack_public_path__ + "static/media/shopee-inbox.69bf8063.svg";